import Banner from "../../sections/common/banner";
import SectionServices from "../../sections/services/customs-law-service/section-services.jsx";
import { data as dataEs } from "../../../globals/data/es/derechoAduaneroService.js";
import { data as dataEn } from "../../../globals/data/en/derechoAduaneroService.js";
import { data as dataCn } from "../../../globals/data/zh/derechoAduaneroService.js";
import { useLangagesStore } from "../../../context/langages";

export default function CustomsLawService() {
    const language = useLangagesStore((state) => state.langage);
    const data = language === "en" ? dataEn : language === "cn" ? dataCn : dataEs;

    return (
        <>
            <Banner _data={data.banner} />
            <SectionServices _data={data.features} />
        </>
    )
}